<template>
  <!-- 机构详情 -->
  <div class="organizationInfoWrap">
     <!-- 机构标题 -->
    <div class="top clearfix">
      <div class="img"><img :src="baseData.iconPath" alt=""></div>
      <div class="text">
        <p class="p1">{{baseData.name}}</p>
        <!-- <p class="p2">国际一流的服务机构国际一流的服务机构国际一流的服务机构国际一流的服务机构国际一流的服务机构国际一流的服务机构</p> -->
      </div>
    </div>
    <div class="line"></div>
    <!-- 机构介绍 -->
    <div class="middle">
      <div class="title">机构介绍</div>
      <div class="con" v-html="baseData.description"></div>
    </div>
    <div class="line"></div>
    <!-- 机构课程 -->
    <div class="classData" v-if="false">
      <div class="title">机构课程</div>
      <ul class="ul">
        <li v-for="item in classList">
          <div class="img"><img :src="item.iconPath" alt=""></div>
          <div class="con">
            <div class="p1">{{item.name}}<div class="price"><span class="s1">￥</span><span class="s2">{{item.price}}</span>/人</div></div>
            <p class="p2">{{item.description}} <span @click="seeInfo(item.courseId)">[了解详情]</span></p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import '../js/flexible.debug.js'
import { Toast,Indicator } from 'mint-ui';
import global from "../js/global.js"
export default {
  data () {
    return {
      baseData:{},
      classList:[],
      // pageType:0,
      token:"",
    }
  },
  created(){
    this.init();
  },
  mounted(){
    window.getToken = this.getToken;
    if(global.getmobiletype()=="android"){
      this.token = control.getToken()
    }
    else{        
        window.webkit.messageHandlers.getToken.postMessage({"mothedName":"getToken"});             
    }
  },
  methods:{
    getToken(token){
      this.token = token;
    },
    init(){
      // this.$http.get("content/institution/getDetails?id="+"5aa10566a32c0900017e1c87"+"&accountId=32")
      this.$http.get("content/institution/getDetails?id="+this.$route.query.contentId+"&accountId="+this.$route.query.accountId)
      .then((response) => {
        this.baseData =  response.respData;        
        this.classList =  response.respData.courseList
        
      });
    },
    seeInfo(id){
      Indicator.open();
      // this.$http.post("content/institution/signup/course?courseId="+id+"&accountId=32","",{headers:{"Authorization":"bearer 747bc7a84edbe83a9af4788a4f20e6c7"}})
      this.$http.post("content/institution/signup/course?courseId="+id+"&accountId="+this.$route.query.accountId,"",{headers:{"Authorization":"bearer "+this.token+""}})
      .then((response) => {
        Indicator.close();
        Toast({
          message:'提交成功，汇殡葬会及时联系您',
          className:'popsName'
        })
      });
      
    }
  }
}
</script>
<style lang="less">
.organizationInfoWrap{
  .middle{
    .con{
      font-size:32px;
      img,video,table{
        max-width: 100%;
      }
    }
  }
}
.popsName{
    font-size: 26px;
    color: #fff;
    padding: 22px 30px !important;
}
</style>

<style lang="less" scoped>
.organizationInfoWrap{
  .top{
    padding: 28px 30px;
    .img{
      float: left;
      width: 200px;
      height: 150px;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .text{
      float: left;
      margin-left: 38px;
      padding-top: 40px;
      max-width: 450px;
      .p1{
        font-weight: bold;
        font-size: 30px;
        color: #333440;
        margin-bottom: 8px;
      }
      .p2{
        font-size: 12px;
        color: #A4A4A4;
      }
    }
  }
  .line{
    height:20px;
    background: #FBF6F6;
  }
  .middle{
    .title{
      line-height: 84px;
      height: 84px;
      font-size: 28px;
      color: #333440;
      font-weight: bold;
      border-bottom: 1px solid #EFEFEF;
      padding: 0 30px;
    }
    .con{
      padding: 20px 30px 28px 30px;
      font-size: 26px;
      line-height: 48px;
      color: #5B5C66;
      img,video{
        max-width: 100%;
      }
    }
  }
  .classData{
    margin-bottom: 142px;
    .title{
      line-height: 84px;
      height: 84px;
      font-size: 28px;
      color: #333440;
      font-weight: bold;
      border-bottom: 1px solid #EFEFEF;
      padding: 0 30px;
      margin-bottom: 4px;
    }
    .ul{
      padding: 0 30px;
      li{
        background: #FFFFFF;
        box-shadow: 0 4px 8px 0 rgba(0,0,0,0.06);
        margin-bottom: 24px;
        .img{
          width: 100%;
          height: 312px;
          display: flex;
          justify-content: center;
          align-items: center;
          img{
            max-width: 100%;
            max-height: 100%;
          }
        }
        .con{
          padding: 20px 24px 28px 24px;
          .p1{
            font-size: 30px;
            color: #333440;
            font-weight: bold;
            margin-bottom: 20px;
            .price{
              float: right;
              font-size: 20px;
              color: #A4A4A4;
              font-weight: normal;
              line-height: 50px;
              .s1{
                color: #F3A117;
              }
              .s2{
                font-size: 36px;
                color: #F3A117;
                font-weight: bold;
                margin: 0 2px;
              }
              
            }
          }
          .p2{
            line-height: 40px;
            font-size: 24px;
            color: #A4A4A4;
            span{
              color: #F3A117;
            }
          }
        }
      }
    }
  }

}
</style>





// WEBPACK FOOTER //
// src/pages/organizationInfo.vue